import React, { Component } from 'react';

import { CircularProgress } from 'material-ui';

import Head from '../../components/Head';
import JoinCard from '../../components/JoinCard';

import { Title } from '../../helper/consts';

import '../../styles/Join.css';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	}
};

export default class Join extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loggedIn: false,
			authLoading: true,
			loading: true,
			email: '',
			password: '',
			fullName: ''
		};
	}

	render() {
		if (this.props.loggedIn && window.location.hash === '#/Join') {
			this.props.history.push('/');
		}
		return (
			<React.Fragment>
				<Head title={`Join | ${Title}`} />
				<div className="body">
					{this.props.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}

					{!this.props.authLoading &&
						!this.props.loggedIn && (
							<div className="joinContainer">
								<JoinCard
									tab={
										this.props.location.state
											? this.props.location.state.tab
											: 'signIn'
									}
								/>
							</div>
						)}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Join/Join.js